let redirectHelperInstance = null;

/**
 * @class RedirectHelper
 */
class RedirectHelper {
    constructor() {
        this.redirectPath = null;
    }

    /**
     * Sets the redirect path
     * @param {string} path - redirect path
     * @returns {undefined}
     */
    setRedirectPath(path) {
        if (path) {
            this.redirectPath = path;
        }
    }

    /**
     * Gets the redirect path
     * @returns {null|string} redirect path
     */
    getRedirectPath() {
        return this.redirectPath;
    }

    static get instance() {
        if (!redirectHelperInstance) {
            redirectHelperInstance = new RedirectHelper();
        }

        return redirectHelperInstance;
    }
}

export default RedirectHelper;
